<template>
    <div class="login col-md-6 col-12 p-0 center">
       
    <div class="modal-content p-0">
      <!-- <div class="modal-header m-0 p-0">
        <div class="back mt-5 ml-3 pt-5">
          <h2 class="modal-title m-0 p-0" id="exampleModalLabel">LOGIN</h2>
        </div>
         <img src="../assets/LOGIN.svg" width="130px" class="mt-5">
        <button type="button" class="close pr-4 pt-4" data-dismiss="modal" aria-label="Close">
          <img src="../assets/close-button.svg" width="22px">
        </button>
      </div> -->
      <div class="modal-body m-0 p-0">
        <div class="col-12 col-md-12 p-0 pt-5 text-center">
          <h2 class="modal-title m-0 p-0" id="exampleModalLabel">Log In</h2>
          <p>Please log in to find your X</p> 
        </div>
        <div class="row text-center mt-5 col-md-8 p-0" style="margin:0 auto">
                    <div class="col-md-3 col-3 mt-4 text-center">
                      <label class="labels "  for="" >Email</label>
                    </div>
                    <div class="col-md-9 col-9 mb-4 mt-3 text-center">
                      <input type="email"  v-model="email" class="inputText form-control" required/>
                      <span class="floating-label" >Enter email</span>
                    </div>
                    <div class="col-md-3 col-3 mt-4 text-center">
                      <label for="" class="labels">Password</label>
                    </div>
                    <div class="col-md-9 col-9 mb-4 mt-3 text-center">
                      <input type="password" v-model="password" class="inputText form-control" required />
                      <span class="floating-label" >Enter password</span>
                      <div class="col-md-12 mb-2 pt-4 mt-3 text-left m-0 p-0">
                        <button class="action-button" v-on:click="log_me">
                          <span v-if="!loading">LOGIN</span>
                          <div v-else class="spinner-border spinner-border-sm"></div>
                        </button>
                    </div>
                    </div>
                    <div class="col-md-12 m-0 p-0 text-center" v-if="response_message">
                        <p class="error">{{response_message}}</p>
                    </div>
                    <div class="col-md-12 mb-4 pt-4">
                        <p class="labels">Don't have Account? <router-link to="/signup" style="color:#f6b949">Sign in.</router-link></p>
                    </div>
            </div>
            <img src="../assets/login-bgx.png" alt="" class="image-labels" height="auto">
            {}
      </div>
    </div>

    </div>
</template>

<script>
export default {
    data(){
        return{
            email:'',
            password:'',
            response_message:'',
            data:[],
            loading:false,
            next:''
        }
    },
    created(){
        this.next=this.$route.query.next || 'profile'
        let auth = localStorage.getItem('token')
        if(auth){
           this.$toasted.show('You are already Signed in.',{
              position: 'bottom-center',
              duration:3000,
              theme:'bubble',
            })
            this.$router.push('/profile')
        }
    },
    methods:{
        log_me(){
            if(this.email){
            this.loading = true
            this.$http.post('https://backend-bikex.herokuapp.com/api/customers/validate',{
              email:this.email,
              password:this.password,
            }).
            then(response=>{
            this.data = response.body;
            if(this.data.err == 0){
                this.response_message = this.data.msg
                
                
                localStorage.setItem('token', this.data.data[0].firstname)
                localStorage.setItem('temp', this.data.data[0]._id)
                this.$router.push('/'+this.next)
                window.location.reload()
            }else{
                this.response_message = this.data.msg 
            }
            this.loading = false
            }).catch(error => { 
                this.response_message = error.body.msg
                this.loading = false
            }) 
    } else{
        this.response_message = 'Please provide your E-mail'
    }
            }
        },
}
</script>

<style  scoped>

.image-labels{
  width: 100%;
}
.highlight:before {
  content : "";
  position: absolute;
  height  : 1px;
  width   : 35px;
  border-top:5px solid #ffb52f;
}

.login{
  min-height: 400px
}
.error{
    color: red;
}
/* .modal-content{
  border: none !important;
  background-image: url("../assets/login.png");
  background-size: contain;
  background-repeat: no-repeat
} */
.modal-content{
  border: none
}
.modal-header{
  min-height: 150px;
  background-color: rgb(0, 18, 51);
  background-image: url("../assets/heroes.png");
  background-size: cover;
  overflow: hidden
}

 .modal-title{
    color: black;
    font-size: 1.5em;
  font-weight: 900
  }
   .labels{
    font-size: 13px;
    font-weight: 500;
  }
.center{
    margin: 0 auto
}
.login{
    background-color: #fefefe;
    margin-top: 20px !important;
    margin-bottom: 50px !important
}
@media only screen and (max-width: 600px) {
  .mobile{
      display: none !important
  }
  .inputText{
      width: 100% !important
  }
  .login{
       margin-top: 60px !important;
       margin-bottom: 50px !important;
      text-align: center !important
  }
}

.inputText {
outline: none !important;
border: none;
border-bottom: 1px solid gray;
border-radius: 0px;
width: 100%
}
.inputText:focus{
    border-bottom: 1px solid red;
}
input:focus, textarea:focus, select:focus{
  outline: none !important;
  box-shadow: none !important
}
.floating-label {
    font-size: 13px;
    font-weight: 500;
    position: absolute;
    pointer-events: none;
    left: 30px;
    top: 8px;
    transition: 0.2s ease all;
}

input:focus ~ .floating-label,
input:not(:focus):valid ~ .floating-label{
  top: -7px;
  padding: 0px 5px 0px 0px;
  background-color: #fefefe;
  left: 20px;
  font-size: 11px;
  opacity: 1;
  z-index: 1;
  outline: none !important;
  box-shadow: none !important
}
.action-button{
    border: 1.5px solid #001232;
    background-color: #000a1b;
    color: white;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    height: inherit;
    letter-spacing: 1px;
    padding: 13px 20px 11px;
    text-transform: uppercase;
    transition: all 0.3s ease 0s;
    width: 60%;
    border-radius: 21px
}
.action-button:hover{
        background-color:  #000a1b;
        opacity: 0.9;
        color:cornsilk;
}

#overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(233, 227, 227, 0.3);
  z-index: 2;
  cursor: pointer;
}

#text{
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>